var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// import regression from "regression";
import * as regression from "regression";
import Plotly from "plotly.js-dist-min";
import { BCGMS_API_URL, createTableFmObject, currentCrop, currentIndicator, currentRa, currentReferencial, currentTemporality, dateToDecade, formatReferenceYearMonth, formatReferenceDecadeShort, formatReferenceYearMonthDay, getCurrentDoy, getCurrentProvider, getCurrentYear, getIndicatorLabel, getRegionAgricoleCode, getRegionAgricoleLabel, getYearMax, getYearMin, hideLoaderBox, hideVariabilitySelector, INDICATORS_PARAMS, initDecadeSelector, initMonthSelector, initYearSelector, resetGeneralGraph, setCalendarDate, setCartoucheBox, showLoaderBox, } from "./tools_02";
import { getSelectInteraction, makeIndicatorUrl, makeMap, makeStatUrl, map, } from "./map_02";
import { RMSE } from "./rmse";
var BLUE = "rgb(55, 128, 191)";
var GREEN = "rgb(35,132,67)";
var GREENLIGHT = "rgb(120, 198, 121)";
var ORANGE = "rgb(255,140,0)";
var RED = "rgb(219, 64, 82)";
var VIOLET = "rgb(138,43,226)";
var blueThickLine = {
    color: BLUE,
    width: 3,
};
var blueThinDottedLine = {
    color: BLUE,
    width: 1.5,
    dash: "dot",
};
var blueThinLine = {
    color: BLUE,
    width: 2,
};
var greenThickLine = {
    color: GREEN,
    width: 3,
};
var greenThinDottedLine = {
    color: GREEN,
    width: 1.5,
    dash: "dot",
};
var greenThinLine = {
    color: GREEN,
    width: 2,
};
var orangeThinDottedLine = {
    color: ORANGE,
    width: 1.5,
    dash: "dot",
};
var redThickLine = {
    color: RED,
    width: 3,
};
var violetThinDottedLine = {
    color: VIOLET,
    width: 1.5,
    dash: "dot",
};
export var generalGraph = (document.getElementById("generalGraph"));
export var itemGraph = document.getElementById("itemGraph");
/* define resize event */
export var autorangeChart = function () {
    Plotly.relayout("generalGraph", {
        "xaxis.autorange": true,
        "yaxis.autorange": true,
    });
};
var DEFAULT_VALIDITY = "inter"; //'intra'
var currentValidity = DEFAULT_VALIDITY;
var MY_MARGIN_B = 120;
var MY_HEIGHT = 625;
var MY_WIDTH = undefined;
var MY_AUTO = true;
// au dessus du graphique
// en dessous du graphique
var LEGEND_H_X_POS = 0.1;
var LEGEND_H_Y_POS = -0.25;
/*
 * This is valid until 2040
 * FIXME every 10 years
 */
var currentYear = new Date().getFullYear();
var NORMALE_Y_START = currentYear > 2030 ? 2001 : 1991;
var NORMALE_Y_END = currentYear > 2030 ? 2030 : 2020;
var font = {
    size: 12,
};
var smallFont = {
    size: 10,
    color: "#333333",
};
/**
 * Compute relative values based on the current referential
 * @param {number[]} values - an array of values
 * @param {number[]} normale - an array of normales values of same length that values
 * @param {string} method - a string defining the method to be used for relative values
 * @returns {number[]} an array of relative or absolute values
 */
export var computeReferencialValues = function (values, normale, method) {
    if (method === void 0) { method = "reldiff"; }
    var referencialValues = [];
    var v = 0;
    switch (currentReferencial) {
        case "rel":
            for (var i = 0; i <= values.length - 1; i++) {
                // FIXME diff or reldiff provient de la db table indices
                switch (method) {
                    case "diff":
                        v = values[i] - normale[i];
                        break;
                    case "reldiff":
                        v = ((values[i] - normale[i]) / normale[i]) * 100;
                        break;
                    default:
                        // let the value unchanged
                        v = values[i];
                }
                referencialValues.push(v);
            }
            break;
        case "abs":
        default:
            referencialValues = values;
            break;
    }
    return referencialValues;
};
var getAnnotation1 = function () {
    return gettext("Les surfaces bleues claires montrent les valeurs extrêmes,");
}; // TODO multilang
var getAnnotation2 = function () {
    return gettext("les surfaces bleues foncées les 1er et 3ème quantiles.");
}; // TODO multilang
var getAverageValueOfArray = function (fdata, units) {
    // Draw the normale line
    var averageValue = {};
    averageValue.x = fdata.x;
    averageValue.type = "line";
    averageValue.mode = "lines+markers";
    averageValue.line = blueThinDottedLine;
    averageValue.name = getNormaleOrAverage();
    averageValue.hovertemplate = "%{y:.3r} ".concat(units);
    var normale = Number((fdata.y.reduce(function (a, b) { return a + b; }, 0) / fdata.y.length).toPrecision(4));
    averageValue.y = Array.from({ length: fdata.y.length }, function (_, _i) { return normale; });
    return averageValue;
};
var getFilenameForPng = function () {
    /**
     * Define the default name of the downloaded png file
     *
     * All regions:
     *
     * code de l’indicateur + « _ » +  date cible + « _ABS »
     * code de l’indicateur + « _ » +  date cible + «_REL »
     *
     * single region:
     *
     * code de l’indicateur + « _ » +  date cible + « _ » + identifiant de la région agricole + abréviation de la région agricole + « _inter »
     * code de l’indicateur + « _ » +  date cible + « _ » + identifiant de la région agricole + abréviation de la région agricole + « _intra »
     *
     */
    var pngFilename = "default";
    var displayDate = "";
    switch (getCurrentProvider()) {
        case "IRM":
            switch (currentTemporality) {
                case "MO":
                    displayDate = "".concat(formatReferenceYearMonth());
                    break;
                case "DC":
                    displayDate = "".concat(formatReferenceDecadeShort());
                    break;
                default:
                    displayDate = "".concat(formatReferenceYearMonthDay());
                    break;
            }
            break;
        case "RS":
            displayDate = "".concat(formatReferenceDecadeShort());
            break;
        default:
            displayDate = "".concat(getCurrentYear());
            break;
    }
    if (currentRa === "") {
        pngFilename = "".concat(currentIndicator, "_").concat(displayDate, "_").concat(currentReferencial);
    }
    else {
        pngFilename = "".concat(currentIndicator, "_").concat(displayDate, "_").concat(currentRa, "_").concat(getRegionAgricoleCode(currentRa), "_").concat(currentValidity);
    }
    // remove any whitespace in the filename
    pngFilename = pngFilename.replace(/ /g, "_");
    return pngFilename;
};
var getHovertemplate = function (xy, units) {
    var hvrtemplate = "";
    switch (xy) {
        case "xy":
            switch (getCurrentProvider()) {
                case "STATBEL":
                    switch (currentIndicator) {
                        case "surface":
                            hvrtemplate = "%{x} -> %{y:.0f} ".concat(units);
                            break;
                        default:
                            hvrtemplate = "%{x} -> %{y:.2f} ".concat(units);
                            break;
                    }
                    break;
                default:
                    hvrtemplate = "%{x} -> %{y:.3r} ".concat(units);
                    break;
            }
            break;
        default:
            hvrtemplate = "%{y:.3r} ".concat(units);
            break;
    }
    // console.log("xy", xy);
    // console.log("currentProvider", getCurrentProvider());
    // console.log("currentIndicator", currentIndicator);
    // console.log("hvrtemplate", hvrtemplate);
    return hvrtemplate;
};
var getNormaleOrAverage = function () {
    var retval = "";
    switch (getCurrentProvider()) {
        case "STATBEL":
            if (currentRa !== "") {
                /** la moyenne est calculée sur toutes les années
                 * cf makeInterannualGraph + getAverageValueOfArray
                 */
                retval = "".concat(gettext("average"), " ").concat(getYearMin(), "-").concat(getYearMax());
            }
            else {
                /**
                 * la moyenne est calculée sans la dernière année voir code
                 * python bcgms.views.api.get_statbel_stats
                 */
                retval = "".concat(gettext("average"), " ").concat(getYearMin(), "-").concat(getCurrentYear() - 1);
            }
            break;
        case "IRM":
            retval = "".concat(gettext("normale"), " ").concat(NORMALE_Y_START, "-").concat(NORMALE_Y_END);
            break;
        default:
            retval = gettext("average");
            break;
    }
    return retval;
};
var getTendanceLineaire = function (fdata) {
    // Draw the tendance lineaire
    //prepare records for linear regression
    var myitems = [];
    var rmseDataset = [];
    for (var i = 0; i < fdata.x.length; i++) {
        myitems[i] = [fdata.x[i], fdata.y[i]];
    }
    // calc linear regression
    var lrResult = regression.linear(myitems, { precision: 4 });
    // calc RMSE
    for (var i = 0; i < fdata.x.length; i++) {
        rmseDataset[i] = [fdata.y[i], lrResult.predict(fdata.x[i])[1]];
    }
    var rmse = RMSE.rmse(rmseDataset).toFixed(2);
    var rse = RMSE.rse(rmseDataset, 2).toFixed(2);
    var tendanceLineaire = {};
    tendanceLineaire.x = fdata.x;
    tendanceLineaire.type = "line";
    tendanceLineaire.mode = "lines+markers";
    tendanceLineaire.line = violetThinDottedLine;
    tendanceLineaire.name = gettext("reg linéaire");
    tendanceLineaire.hovertemplate = "%{x} -> %{y:.3r}";
    tendanceLineaire.y = lrResult.points.map(function (x) { return x[1]; });
    tendanceLineaire.equation = lrResult.string.replace(/ \+ -/g, " - ");
    tendanceLineaire.a = lrResult.equation[0];
    tendanceLineaire.b = lrResult.equation[1];
    tendanceLineaire.r2 = lrResult.r2;
    tendanceLineaire.rmse = rmse;
    tendanceLineaire.rse = rse;
    return tendanceLineaire;
};
var getTendanceQuadratique = function (fdata) {
    // Draw the tendance quadratique = polynomial of order 2
    //prepare records for linear regression
    var myitems = [];
    var rmseDataset = [];
    var equation = "";
    for (var i = 0; i < fdata.x.length; i++) {
        myitems[i] = [fdata.x[i], fdata.y[i]];
    }
    // calc linear regression quadratic
    var lrqResult = regression.polynomial(myitems, { order: 2, precision: 10 });
    // calc RMSE
    for (var i = 0; i < fdata.x.length; i++) {
        rmseDataset[i] = [fdata.y[i], lrqResult.predict(fdata.x[i])[1]];
    }
    var rmse = RMSE.rmse(rmseDataset).toFixed(2);
    var rse = RMSE.rse(rmseDataset, 3).toFixed(2);
    var tendanceQuadratique = {};
    tendanceQuadratique.x = fdata.x;
    tendanceQuadratique.type = "line";
    tendanceQuadratique.mode = "lines+markers";
    tendanceQuadratique.line = orangeThinDottedLine;
    tendanceQuadratique.name = gettext("reg quadratique");
    tendanceQuadratique.hovertemplate = "%{x} -> %{y:.3r}";
    tendanceQuadratique.y = lrqResult.points.map(function (x) { return x[1]; });
    tendanceQuadratique.equation = lrqResult.string.replace(/ \+ -/g, " - ");
    tendanceQuadratique.a = lrqResult.equation[0];
    tendanceQuadratique.b = lrqResult.equation[1];
    tendanceQuadratique.c = lrqResult.equation[2];
    tendanceQuadratique.r2 = lrqResult.r2;
    tendanceQuadratique.rmse = rmse;
    tendanceQuadratique.rse = rse;
    return tendanceQuadratique;
};
export var initGraphSelectors = function () {
    /**
     * Initialize validity selector
     */
    switch (getCurrentProvider()) {
        case "STATBEL":
        case "FCST":
            break;
        case "IRM":
        case "RS":
        default:
            (document.getElementById("".concat(currentValidity, "annual"))).checked = true;
            break;
    }
};
// Graphiques avec RA sélectionnée
export var loadDataForItemGraph = function (indicator, ra) {
    showLoaderBox();
    var url;
    var indicatorTlNormale;
    // const switchItemGraph = <HTMLInputElement>(
    //   document.getElementById("switchItemGraph")
    // );
    var indicator_params = INDICATORS_PARAMS[indicator];
    if (indicator_params.provider === "STATBEL") {
        // hide the button to swith to intrannual (not needed)
        // const switchItemGraphWrapper = document.getElementById(
        //   "switchItemGraphWrapper"
        // );
        // switchItemGraphWrapper!.classList.add("d-none");
        hideVariabilitySelector();
        // statbel interannual
        // fetch the data get the indicator data
        url = "".concat(BCGMS_API_URL, "statbel/").concat(indicator, "/").concat(currentCrop, "/?ra=").concat(ra, "&yearmin=").concat(getYearMin(), "&yearmax=").concat(getYearMax());
        fetch(url)
            .then(function (response) {
            return response.json().then(function (data) {
                var indicatorInterannual = parseInterannualResults(data.results);
                makeInterannualGraph(indicator, indicatorInterannual, true);
                hideLoaderBox();
            });
        })
            .catch(function (error) {
            return console.error(gettext("There has been a problem with your fetch operation:"), error);
        });
        // fetch the quadratic regression data with a second ajax call
    }
    else if (currentValidity === "inter") {
        // other interannual
        url =
            indicator_params.provider === "IRM"
                ? "".concat(BCGMS_API_URL, "kmi-irm/").concat(indicator, "/").concat(getCurrentDoy(), "/?ra=").concat(ra)
                : "".concat(BCGMS_API_URL, "vito/").concat(indicator, "/?ra=").concat(ra, "&doy=").concat(getCurrentDoy());
        fetch(url)
            .then(function (response) {
            return response.json().then(function (data) {
                var indicatorInterannual = parseInterannualResults(data.results);
                makeInterannualGraph(indicator, indicatorInterannual);
                hideLoaderBox();
            });
        })
            .catch(function (error) {
            return console.error(gettext("There has been a problem with your fetch operation:"), error);
        });
    }
    else {
        //if (currentValidity === "intra")
        // intrannual
        var doy_1 = getCurrentDoy();
        if (getCurrentProvider() == "RS") {
            if (getCurrentYear() < new Date().getFullYear()) {
                // doy = 366;
                doy_1 = 365;
            }
        }
        if (indicator_params.provider === "IRM") {
            // get the normale
            url = "".concat(BCGMS_API_URL, "kmi-irm/").concat(indicator, "/tl-normale/").concat(doy_1, "/").concat(ra, "/");
            fetch(url)
                .then(function (response) {
                return response
                    .json()
                    .then(function (data) {
                    indicatorTlNormale = parseTlNormaleResults(data);
                    // get the indicator data with a second ajax call
                    var url2 = "".concat(BCGMS_API_URL, "kmi-irm/").concat(indicator, "/time-lapse/").concat(doy_1, "/").concat(getCurrentYear(), "/").concat(ra, "/");
                    return fetch(url2);
                })
                    .then(function (response) {
                    return response.json().then(function (data) {
                        var indicatorTimeLapse = parseTimeLapseResults(data.results);
                        makeIntrannualGraph(indicator, indicatorTimeLapse, indicatorTlNormale);
                        hideLoaderBox();
                    });
                });
            })
                .catch(function (error) {
                return console.error(gettext("There has been a problem with normale fetch operation:"), error);
            });
        }
        else {
            url = "".concat(BCGMS_API_URL, "vito/").concat(indicator, "/time-lapse/?year=").concat(getCurrentYear(), "&ra=").concat(ra, "&doy=").concat(doy_1);
            fetch(url)
                .then(function (response) {
                return response.json().then(function (data) {
                    var indicatorTimeLapse = parseTimeLapseResults(data.results);
                    makeIntrannualGraph(indicator, indicatorTimeLapse);
                    hideLoaderBox();
                });
            })
                .catch(function (error) {
                return console.error(gettext("There has been a problem with your fetch operation:"), error);
            });
        }
    }
};
// Carte et graphiques pour toute la Belgique
export var loadDataForMapAndGraph = function (indicator, resetCalendar) {
    // console.log(indicator);
    // console.log(currentCrop.toString());
    if (resetCalendar === void 0) { resetCalendar = false; }
    showLoaderBox();
    fetch(makeStatUrl(indicator, currentCrop.toString(), resetCalendar))
        .then(function (response) {
        return response.json().then(function (statData) {
            fetch(makeIndicatorUrl(indicator, resetCalendar ? "closest" : getCurrentYear().toString(), getCurrentDoy().toString(), currentCrop.toString()))
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var indicatorCurrentYear = parseIndicatorResults(data.results);
                /**
                 * Reset the value of the calendar to the last available date
                 * in the database for this indicator
                 * This is useful only at first load to avoid dispalying no data
                 */
                if (resetCalendar === true) {
                    switch (INDICATORS_PARAMS[indicator].provider) {
                        case "RS":
                            setCalendarDate(new Date(data.results[0].reference_date));
                            initDecadeSelector();
                            initYearSelector();
                            break;
                        case "IRM":
                            setCalendarDate(new Date(data.results[0].reference_date));
                        default:
                            initYearSelector();
                            break;
                    }
                }
                var indicatorStat = {};
                switch (INDICATORS_PARAMS[indicator].provider) {
                    case "FCST":
                        indicatorStat = parseForecastsStats(statData.results);
                        makeForecastsGraph(indicator, indicatorCurrentYear, indicatorStat);
                        break;
                    case "IRM":
                    case "STATBEL":
                    case "RS":
                    default:
                        indicatorStat = parseStatsResults(statData.results);
                        makeGraph(indicator, indicatorCurrentYear, indicatorStat);
                        break;
                }
                makeMap(indicator, indicatorCurrentYear, indicatorStat);
                hideLoaderBox();
            })
                .catch(function (error) {
                return console.error(gettext("There has been a problem with your secondary fetch operation:"), error);
            });
        });
    })
        .catch(function (error) {
        return console.error(gettext("There has been a problem with your primary fetch operation:"), error);
    });
};
var makeForecastsGraph = function (indicator, actualData, statData) {
    if (statData === void 0) { statData = undefined; }
    var myunits = currentReferencial === "abs" ? INDICATORS_PARAMS[indicator].unit : "%";
    /**
     * Format output of refdate
     */
    var dtopts = { year: "numeric", month: "numeric", day: "numeric" };
    var refdate = new Date(actualData.refdate).toLocaleString("fr-BE", dtopts);
    actualData.type = "bar";
    actualData.marker = {
        color: RED,
    };
    actualData.name = "".concat(gettext("prévision du"), " ").concat(refdate);
    actualData.hovertemplate = "%{y:.3r} ".concat(myunits); //"%{y:.3r}";
    var five_yr_avgData = {};
    var last_yrData = {};
    var zeroData = true;
    if (statData !== undefined) {
        for (var i = 0; i <= statData.x.length - 1; i++) {
            if (statData.five_yr_avg[i] !== 0 && statData.last_yr[i] !== 0) {
                zeroData = false;
            }
        }
        if (!zeroData) {
            var yArray = [];
            // Draw the five_yr_avgData bar
            five_yr_avgData.x = actualData.x;
            five_yr_avgData.type = "bar";
            // five_yr_avgData.line = blueThinLine;
            five_yr_avgData.marker = {
                color: GREENLIGHT,
                opacity: 0.7,
            };
            for (var i = 0; i <= five_yr_avgData.x.length - 1; i++) {
                var stat_idx = statData.x.indexOf(five_yr_avgData.x[i]);
                yArray.push(statData.five_yr_avg[stat_idx]);
            }
            five_yr_avgData.y = yArray;
            five_yr_avgData.name = gettext("moyenne des 5 dernières années");
            five_yr_avgData.hovertemplate = "%{y:.3r} ".concat(myunits); //"%{y:.3r}";
            // Draw the last_yrData bar
            last_yrData.x = actualData.x;
            last_yrData.type = "bar";
            // last_yrData.line = greenThinLine;
            last_yrData.marker = {
                color: GREEN,
                opacity: 0.7,
            };
            yArray = [];
            for (var i = 0; i <= last_yrData.x.length - 1; i++) {
                var stat_idx = statData.x.indexOf(last_yrData.x[i]);
                yArray.push(statData.last_yr[stat_idx]);
            }
            last_yrData.y = yArray;
            last_yrData.name = gettext("année-1");
            last_yrData.hovertemplate = "%{y:.3r} ".concat(myunits); //"%{y:.3r}";
        }
    }
    var plotData = [];
    if (statData !== undefined && !zeroData) {
        plotData.push(actualData, last_yrData, five_yr_avgData);
    }
    else {
        plotData.push(actualData);
    }
    var layout = {
        autosize: MY_AUTO,
        barmode: "group",
        height: MY_HEIGHT,
        width: MY_WIDTH,
        separators: ",.",
        xaxis: {
            title: {
                text: gettext("Régions agricoles"),
                font: font,
            },
        },
        yaxis: {
            title: {
                text: getIndicatorLabel(indicator),
                font: font,
            },
            range: null,
        },
        legend: {
            orientation: "h",
            y: LEGEND_H_Y_POS - 0.02,
            // x: LEGEND_H_X_POS,
        },
        margin: {
            b: MY_MARGIN_B,
        },
    };
    if (zeroData) {
        layout.yaxis.range = [0, 10]; // Set a default y-axis range in case of zero data
    }
    /** add custom plotly config */
    var pltconfig = {
        toImageButtonOptions: {
            format: "png",
            filename: getFilenameForPng(),
            // height: 500,
            // width: 700,
            // scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
        },
    };
    itemGraph.classList.add("d-none");
    generalGraph.classList.remove("d-none");
    Plotly.newPlot("generalGraph", plotData, layout, pltconfig);
};
/*
 * Make a graph with Plotly based on a data structure
 * @param {string} indicator - indicator name
 * @param {object} actualData - object with the following properties
 *    - x {any[]} - an array of x data, e.g. an array of strings
 *    - y {any[]} - an array of y data, e.g, an array of numbers
 *    - name {string} - an array of label data, e.g., an array of strings
 * @param {object} statData
 */
var makeGraph = function (indicator, actualData, statData) {
    var myunits = currentReferencial === "abs" ? INDICATORS_PARAMS[indicator].unit : "%";
    var layout = {
        autosize: MY_AUTO,
        height: MY_HEIGHT,
        width: MY_WIDTH,
        separators: ",.",
        xaxis: {
            title: {
                text: gettext("Régions agricoles"),
                font: font,
            },
        },
        yaxis: {
            title: {
                text: getIndicatorLabel(indicator),
                font: font,
            },
            range: null,
        },
        legend: {
            orientation: "h",
            y: LEGEND_H_Y_POS,
            // x: LEGEND_H_X_POS,
        },
        margin: {
            b: MY_MARGIN_B,
        },
        annotations: null,
    };
    var maxDataLabel = {};
    var minDataLabel = {};
    var minMaxRangeData = {};
    var mainData = __assign({}, actualData);
    var normaleData = {};
    var quantileRangeData = {};
    var normaleArray = [];
    var plotData = [];
    var zeroData = true;
    // Build a normale array based on the order of actualData
    for (var i = 0; i <= actualData.x.length - 1; i++) {
        var stat_idx = statData.x.indexOf(actualData.x[i]);
        normaleArray.push(statData.normale[stat_idx]);
    }
    mainData.y = computeReferencialValues(actualData.y, normaleArray);
    mainData.type = "scatter";
    mainData.mode = "lines+markers";
    mainData.line = redThickLine;
    mainData.name = getCurrentYear();
    // mainData.hovertemplate = `%{x} -> %{y:.3r} ${myunits}`;
    mainData.hovertemplate = getHovertemplate("xy", myunits);
    // if (actualData.x.length > 0) {
    //   for (let i = 0; i <= statData.x.length - 1; i++) {
    //     if (
    //       statData.min[i] !== 0 &&
    //       statData.max[i] !== 0 &&
    //       statData.normale[i] !== 0 &&
    //       statData.q1[i] !== 0 &&
    //       statData.q3[i] !== 0
    //     ) {
    //       zeroData = false;
    //     }
    //   }
    // }
    if (actualData.x.length > 0) {
        zeroData = false;
    }
    if (!zeroData) {
        // Draw the text of min and max data
        minDataLabel.x = statData.x;
        minDataLabel.y = computeReferencialValues(statData.min, normaleArray);
        minDataLabel.text = statData.year_min;
        minDataLabel.textfont = smallFont;
        minDataLabel.type = "scatter";
        minDataLabel.mode = "text";
        minDataLabel.textposition = "bottom center";
        minDataLabel.showlegend = false;
        minDataLabel.hoverinfo = "none";
        maxDataLabel.x = statData.x;
        maxDataLabel.y = computeReferencialValues(statData.max, normaleArray);
        maxDataLabel.text = statData.year_max;
        maxDataLabel.textfont = smallFont;
        maxDataLabel.type = "scatter";
        maxDataLabel.mode = "text";
        maxDataLabel.textposition = "top center";
        maxDataLabel.textfont_size = 10;
        maxDataLabel.fill = "tonexty";
        maxDataLabel.showlegend = false;
        maxDataLabel.hoverinfo = "none";
        // Draw a large errorbar for showing the min and max range
        minMaxRangeData.x = mainData.x;
        minMaxRangeData.y = computeReferencialValues(normaleArray, normaleArray);
        minMaxRangeData.type = "scatter";
        minMaxRangeData.mode = "markers";
        minMaxRangeData.showlegend = false;
        minMaxRangeData.hoverinfo = "none";
        var minArray = [];
        var maxArray = [];
        switch (currentReferencial) {
            case "rel":
                for (var i = 0; i <= mainData.x.length - 1; i++) {
                    var stat_idx = statData.x.indexOf(mainData.x[i]);
                    minArray.push((-(statData.min[stat_idx] - normaleArray[i]) / normaleArray[i]) *
                        100);
                    maxArray.push(((statData.max[stat_idx] - normaleArray[i]) / normaleArray[i]) * 100);
                }
                break;
            case "abs":
            default:
                for (var i = 0; i <= mainData.x.length - 1; i++) {
                    var stat_idx = statData.x.indexOf(mainData.x[i]);
                    minArray.push(normaleArray[i] - statData.min[stat_idx]);
                    maxArray.push(statData.max[stat_idx] - normaleArray[i]);
                }
                break;
        }
        minMaxRangeData.error_y = {
            symmetric: false,
            array: maxArray,
            arrayminus: minArray,
            thickness: 16,
            width: 0,
            color: BLUE,
            opacity: 0.4,
        };
        // Draw an errorbar for showing the q1 and q3 range
        quantileRangeData.x = mainData.x;
        quantileRangeData.y = computeReferencialValues(normaleArray, normaleArray);
        quantileRangeData.type = "scatter";
        quantileRangeData.mode = "markers";
        quantileRangeData.showlegend = false;
        quantileRangeData.hoverinfo = "none";
        var q1Array = [];
        var q3Array = [];
        switch (currentReferencial) {
            case "rel":
                for (var i = 0; i <= mainData.x.length - 1; i++) {
                    var stat_idx = statData.x.indexOf(mainData.x[i]);
                    q1Array.push((-(statData.q1[stat_idx] - normaleArray[i]) / normaleArray[i]) * 100);
                    q3Array.push(((statData.q3[stat_idx] - normaleArray[i]) / normaleArray[i]) * 100);
                }
                break;
            case "abs":
            default:
                for (var i = 0; i <= quantileRangeData.x.length - 1; i++) {
                    var stat_idx = statData.x.indexOf(quantileRangeData.x[i]);
                    q1Array.push(normaleArray[i] - statData.q1[stat_idx]);
                    q3Array.push(statData.q3[stat_idx] - normaleArray[i]);
                }
                break;
        }
        quantileRangeData.error_y = {
            symmetric: false,
            array: q3Array,
            arrayminus: q1Array,
            thickness: 16,
            width: 0,
            color: BLUE,
            opacity: 0.5,
        };
        // Draw the normale line
        normaleData.x = mainData.x;
        normaleData.type = "scatter";
        normaleData.mode = "lines+markers";
        normaleData.line = blueThinLine;
        normaleData.y = computeReferencialValues(normaleArray, normaleArray);
        normaleData.name = getNormaleOrAverage();
        normaleData.hovertemplate = "%{x} -> %{y:.3r} ".concat(myunits);
        // prepare plot
        plotData.push(quantileRangeData, minMaxRangeData, mainData, minDataLabel, maxDataLabel, normaleData);
        // add annotations
        switch (getCurrentProvider()) {
            case "IRM":
            case "RS":
            case "STATBEL":
                layout.annotations = [
                    {
                        xref: "paper",
                        yref: "paper",
                        x: 0,
                        xanchor: "left",
                        y: 1.09,
                        yanchor: "bottom",
                        text: getAnnotation1(),
                        showarrow: false,
                    },
                    {
                        xref: "paper",
                        yref: "paper",
                        x: 0,
                        xanchor: "left",
                        y: 1.05,
                        yanchor: "bottom",
                        text: getAnnotation2(),
                        showarrow: false,
                    },
                ];
                break;
            case "FCST":
            default:
                break;
        }
    }
    else {
        // display a message that data are missing
        layout.xaxis.visible = false;
        layout.yaxis.visible = false;
        layout.annotations = [
            {
                text: gettext("Aucun jour n’a été enregistré <br> au sein des régions agricoles <br> pour la variable considérée"),
                xref: "paper",
                yref: "paper",
                showarrow: false,
                font: {
                    size: 28,
                },
            },
        ];
    }
    /** add custom plotly config */
    var pltconfig = {
        toImageButtonOptions: {
            format: "png",
            filename: getFilenameForPng(),
            // height: 500,
            // width: 700,
            // scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
        },
    };
    // draw the final result
    itemGraph.classList.add("d-none");
    generalGraph.classList.remove("d-none");
    Plotly.newPlot("generalGraph", plotData, layout, pltconfig);
};
var makeInterannualGraph = function (indicator, interannualData, blnTendance) {
    if (blnTendance === void 0) { blnTendance = false; }
    var courbes = [];
    var messages = [];
    var message = {};
    var myunits = INDICATORS_PARAMS[indicator].unit;
    var layout = {
        autosize: MY_AUTO,
        height: MY_HEIGHT,
        width: MY_WIDTH,
        separators: ",.",
        xaxis: {
            // type: 'category',
            title: {
                text: gettext("Years"),
                font: font,
            },
        },
        yaxis: {
            title: {
                text: getIndicatorLabel(indicator),
                font: font,
            },
        },
        title: {
            text: getRegionAgricoleLabel(currentRa),
        },
        legend: {
            orientation: "h",
            y: LEGEND_H_Y_POS,
            x: LEGEND_H_X_POS,
        },
        margin: {
            b: MY_MARGIN_B,
        },
    };
    setCartoucheBox("");
    if (interannualData.x.length > 2 &&
        interannualData.x.includes(getCurrentYear())) {
        interannualData.type = "scatter";
        interannualData.mode = "lines+markers";
        interannualData.line = greenThickLine;
        interannualData.name = indicator;
        // interannualData.hovertemplate = `%{x} -> %{y:.3r} ${myunits}`;
        interannualData.hovertemplate = getHovertemplate("xy", myunits);
        courbes.push(interannualData);
        /*
         * FIXME how to remove the years before NORMALE_Y_START
         * To be found before 2030
         * remove all values out of the normale years for the averageValue calculation
         */
        var interNormalData = __assign({}, interannualData);
        // interNormalData.x = interNormalData.x.filter(
        //   (item: any) => item <= NORMALE_Y_END
        // );
        var intervalOfCalculation = interNormalData.x.filter(function (item) { return item <= NORMALE_Y_END; }).length;
        var extraItems = interNormalData.x.length - intervalOfCalculation;
        interNormalData.y = interNormalData.y.slice(0, intervalOfCalculation);
        var averageValue = getAverageValueOfArray(interNormalData, myunits);
        /**
         * add all the removed y items with tha calculated average value
         */
        var myAvgVal = averageValue.y[0];
        for (var i = 0; i < extraItems; i++) {
            averageValue.y.push(myAvgVal);
        }
        courbes.push(averageValue);
        if (blnTendance === true) {
            /**
             * calculate linear regressions
             */
            var tendanceLineaire = getTendanceLineaire(interannualData);
            courbes.push(tendanceLineaire);
            /**
             * Add info into cartouche
             */
            message = {};
            message[gettext("tendance")] = gettext("linéaire");
            message["a"] = tendanceLineaire.a.toFixed(4);
            message["b"] = tendanceLineaire.b.toFixed(4);
            message["c"] = "";
            message["r2"] = tendanceLineaire.r2.toFixed(2);
            message["rmse"] = tendanceLineaire.rmse;
            message["rse"] = tendanceLineaire.rse;
            messages.push(message);
            var tendanceQuadratique = getTendanceQuadratique(interannualData);
            courbes.push(tendanceQuadratique);
            /**
             * Add info into cartouche
             */
            message = {};
            message[gettext("tendance")] = gettext("quadratique");
            message["a"] = tendanceQuadratique.a.toFixed(4);
            message["b"] = tendanceQuadratique.b.toFixed(4);
            message["c"] = tendanceQuadratique.c.toFixed(4);
            message["r2"] = tendanceQuadratique.r2.toFixed(2);
            message["rmse"] = tendanceQuadratique.rmse;
            message["rse"] = tendanceQuadratique.rse;
            messages.push(message);
            /**
             * Add cartouche table to pane__message
             */
            setCartoucheBox(createTableFmObject(messages), "append");
        }
    }
    else {
        // display a message that data are missing
        layout.xaxis.visible = false;
        layout.yaxis.visible = false;
        layout.annotations = [
            {
                text: gettext("Aucun jour n’a été enregistré <br> au sein des régions agricoles <br> pour la variable considérée"),
                xref: "paper",
                yref: "paper",
                showarrow: false,
                font: {
                    size: 28,
                },
            },
        ];
    }
    /** add custom plotly config */
    var pltconfig = {
        toImageButtonOptions: {
            format: "png",
            filename: getFilenameForPng(),
            // height: 500,
            // width: 700,
            // scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
        },
    };
    itemGraph.classList.remove("d-none");
    generalGraph.classList.add("d-none");
    Plotly.newPlot("itemGraph", courbes, layout, pltconfig);
};
// const modifyLegendYear = (date: Date, newYear: number): Date => {
//   date.setFullYear(newYear);
//   return date;
// };
var makeIntrannualGraph = function (indicator, timelapseData, indicatorTlNormale) {
    if (indicatorTlNormale === void 0) { indicatorTlNormale = null; }
    var courbes = [];
    var indicator_params = INDICATORS_PARAMS[indicator];
    var myunits = INDICATORS_PARAMS[indicator].unit;
    var layout = {
        autosize: MY_AUTO,
        height: MY_HEIGHT,
        width: MY_WIDTH,
        separators: ",.",
        xaxis: null,
        yaxis: {
            title: {
                text: getIndicatorLabel(indicator),
                font: font,
            },
        },
        title: {
            text: getRegionAgricoleLabel(currentRa),
        },
        legend: {
            orientation: "h",
            y: LEGEND_H_Y_POS,
            // x: LEGEND_H_X_POS,
        },
        margin: {
            b: MY_MARGIN_B,
        },
    };
    if (timelapseData.x.length > 0) {
        timelapseData.type = "scatter";
        timelapseData.mode = "lines";
        timelapseData.line = blueThickLine;
        timelapseData.name = getCurrentYear();
        timelapseData.hovertemplate = "%{x|%d %b} -> %{y:.3r} ".concat(myunits);
        if (indicator_params.provider === "RS" || currentTemporality === "DC") {
            /**
             * Modify xaxis to display decades
             */
            var decadelegend = timelapseData.x.map(function (x) { return dateToDecade(new Date(x)); });
            layout.xaxis = {
                title: {
                    text: "Decades",
                    font: font,
                },
                tickvals: timelapseData.x,
                ticktext: decadelegend,
            };
        }
        else {
            // let datelegend = timelapseData.x.map((x) =>
            //   modifyLegendYear(new Date(x), getCurrentYear())
            // );
            layout.xaxis = {
                type: "date",
                title: {
                    text: "Dates",
                    font: font,
                },
                tickformat: "%d/%m",
            };
        }
        courbes.push(timelapseData);
        if (indicatorTlNormale) {
            indicatorTlNormale.type = "line";
            indicatorTlNormale.mode = "lines";
            indicatorTlNormale.line = greenThinDottedLine;
            indicatorTlNormale.name = getNormaleOrAverage();
            indicatorTlNormale.hovertemplate = "%{x|%d %b} -> %{y:.3r} ".concat(myunits);
            courbes.push(indicatorTlNormale);
        }
    }
    else {
        // display a message that data are missing
        layout.xaxis.visible = false;
        layout.yaxis.visible = false;
        layout.annotations = [
            {
                text: gettext("Aucun jour n’a été enregistré <br> au sein des régions agricoles <br> pour la variable considérée"),
                xref: "paper",
                yref: "paper",
                showarrow: false,
                font: {
                    size: 28,
                },
            },
        ];
    }
    /** add custom plotly config */
    var pltconfig = {
        toImageButtonOptions: {
            format: "png",
            filename: getFilenameForPng(),
            // height: 500,
            // width: 700,
            // scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
        },
    };
    itemGraph.classList.remove("d-none");
    generalGraph.classList.add("d-none");
    Plotly.newPlot("itemGraph", courbes, layout, pltconfig);
};
var numberOrNull = function (value) {
    var result;
    if (value === null) {
        result = null;
    }
    else {
        result = Number(value);
    }
    return result;
};
export var onCloseItemGraphButton = function () {
    getSelectInteraction(map).getFeatures().clear();
    resetGeneralGraph();
    initYearSelector();
    initDecadeSelector();
    initMonthSelector();
};
export var onSwitchItemGraphButton = function (e) {
    currentValidity = e.target.value;
    initYearSelector();
    initDecadeSelector();
    initMonthSelector();
    loadDataForItemGraph(currentIndicator, currentRa);
};
var parseForecastsStats = function (results) {
    var indicatorCollection = {};
    var ra = [];
    var five_yr_avg = [];
    var last_yr = [];
    for (var i = 0; i <= results.length - 1; i++) {
        if (Number(results[i].zone_id) !== 0) {
            ra.push(getRegionAgricoleLabel(results[i].zone_id));
            five_yr_avg.push(numberOrNull(results[i].five_yr_avg));
            last_yr.push(numberOrNull(results[i].last_yr));
        }
    }
    indicatorCollection.x = ra;
    indicatorCollection.five_yr_avg = five_yr_avg;
    indicatorCollection.last_yr = last_yr;
    return indicatorCollection;
};
export var parseIndicatorResults = function (results) {
    var indicatorCollection = {};
    var ra_id = [];
    var ra = [];
    var q1 = [];
    var q3 = [];
    var value = [];
    var text = [];
    var refdate = [];
    for (var i = 0; i <= results.length - 1; i++) {
        if (Number(results[i].zone_id) !== 0) {
            ra_id.push(results[i].zone_id);
            q1.push(results[i].data_q1);
            q3.push(results[i].data_q3);
            ra.push(getRegionAgricoleLabel(results[i].zone_id));
            value.push(numberOrNull(results[i].data_avg)); // add an very small value to avoid strictly equal values
            text.push(Number(results[i].year));
            refdate.push(results[i].reference_date);
        }
    }
    /**
     * 2021-07-20 JPH modified sorting on the basis of ra.sort_fld (see ra model)
     * to always have the same sequence of ra on the x axis
     */
    indicatorCollection.x = ra;
    indicatorCollection.ra_id = ra_id;
    indicatorCollection.q1 = q1;
    indicatorCollection.q3 = q3;
    indicatorCollection.y = value;
    indicatorCollection.text = text;
    indicatorCollection.refdate = refdate[0];
    return indicatorCollection;
};
var parseInterannualResults = function (results) {
    var indicatorCollection = {};
    var x = [];
    var y = [];
    for (var i = 0; i <= results.length - 1; i++) {
        x.push(results[i].year);
        y.push(numberOrNull(results[i].data_avg));
    }
    indicatorCollection.x = x;
    indicatorCollection.y = y;
    return indicatorCollection;
};
export var parseStatsResults = function (results) {
    var indicatorCollection = {};
    var ra = [];
    var min = [];
    var max = [];
    var year_min = [];
    var year_max = [];
    var normale = [];
    var q1 = [];
    var q3 = [];
    for (var i = 0; i <= results.length - 1; i++) {
        if (Number(results[i].zone_id) !== 0) {
            ra.push(getRegionAgricoleLabel(results[i].zone_id));
            min.push(numberOrNull(results[i].min));
            max.push(numberOrNull(results[i].max));
            year_min.push(Number(results[i].year_min));
            year_max.push(Number(results[i].year_max));
            normale.push(numberOrNull(results[i].norm));
            q1.push(numberOrNull(results[i].q1));
            q3.push(numberOrNull(results[i].q3));
        }
    }
    indicatorCollection.x = ra;
    indicatorCollection.min = min;
    indicatorCollection.max = max;
    indicatorCollection.year_min = year_min;
    indicatorCollection.year_max = year_max;
    indicatorCollection.normale = normale;
    indicatorCollection.q1 = q1;
    indicatorCollection.q3 = q3;
    return indicatorCollection;
};
var parseTimeLapseResults = function (results) {
    var indicatorCollection = {};
    var x = [];
    var y = [];
    for (var i = 0; i <= results.length - 1; i++) {
        x.push(results[i].reference_date);
        y.push(numberOrNull(results[i].data_avg));
    }
    indicatorCollection.x = x;
    indicatorCollection.y = y;
    return indicatorCollection;
};
var parseTlNormaleResults = function (results) {
    var indicatorNormale = {};
    var x = [];
    var y = [];
    for (var i = 0; i <= results.length - 1; i++) {
        x.push(results[i].reference_date);
        y.push(numberOrNull(results[i].data_avg__avg));
    }
    indicatorNormale.x = x;
    indicatorNormale.y = y;
    return indicatorNormale;
};
export var wipeGraph = function () {
    var graph = document.querySelector("div.panel__graph");
    graph.innerHTML = "";
    var info = document.querySelector("div.panel__info");
    info.innerHTML = "";
};
